import { render, staticRenderFns } from "./DisplayAnnouncement.vue?vue&type=template&id=8d526518"
import script from "./DisplayAnnouncement.vue?vue&type=script&lang=js"
export * from "./DisplayAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./DisplayAnnouncement.vue?vue&type=style&index=0&id=8d526518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports